import { MenuItem } from "@mui/material";
import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFormDiagnosis } from "../../../../actions/forms";
import DarkerDisabledTextFieldWrapper from "../../../commons/formComponents/darkerDisabledTextField";
import FormikAutocomplete from "../../../commons/formik/formikAutocomplete";
import FormikSelect from "../../../commons/formik/formikSelect";
import FormikTextFieldSpeech from "../../../commons/formik/formikTextFieldSpeech";
import { StyledCommonForms } from "../../../styled/form";
import NaturalezaLesionControl from "./controls/naturalezaLesionControl";
import ZonaAfectadaControl from "./controls/zonaAfectadaControl";


const DiagnosisControl = ({
  fields,
  disabledIfInitialValueExists,
  disabled,
  idArt,
  showGravedad,
  showDescripcionDiagnostico,
  showDiagnosticoInformadoArt,
  naturalezasLesion,
  zonasAfectadas,
  updateFilteredNaturalezasLesion,
  updateFilteredZonasAfectadas,
  getDiagnosticoNaturalezaLesionZonaAfectada,
  clearDiagnosisInitialInclusions,
}) => {
  const { setFieldValue, initialValues, values } = useFormikContext();
  const dispatch = useDispatch();
  const diagnosis = useSelector((state) => state.forms.diagnosis);

  const disableZonaAfectada = disabled || (disabledIfInitialValueExists && initialValues.zonaAfectada);

  const disableNaturalezaLesion = disabled || (disabledIfInitialValueExists && initialValues.naturalezaLesion)

  useEffect(() => {
    if (showDiagnosticoInformadoArt) {
      setFieldValue("diagnosticoOMS", null);
    }
  }, [showDiagnosticoInformadoArt])

  return (
    <>
      <StyledCommonForms.RowContainer>
        <FormikAutocomplete
          name="diagnosticoOMS"
          label={`Diagnóstico Código OMS ${fields.diagnosticoOMS.required ? "*" : ""
            }`}
          variant="outlined"
          options={diagnosis.data}
          callBack={(value) => {
            let newValueZonaAfectada = value?.zonaAfectada ?? values.zonaAfectada;
            let newValueNaturalezaLesion = value?.naturalezaLesion ?? values.naturalezaLesion;
            clearDiagnosisInitialInclusions();
            getDiagnosticoNaturalezaLesionZonaAfectada(value?.id, value?.naturalezaLesion, value?.zonaAfectada, (newFilteredNaturalezaLesion, newFilteredZonasAfectadas) => {
              if (newFilteredZonasAfectadas.length === 1) {
                newValueZonaAfectada = newFilteredZonasAfectadas[0].id;
              }
              if (newFilteredNaturalezaLesion.length === 1) {
                newValueNaturalezaLesion = newFilteredNaturalezaLesion[0].id;
              }
              // usamos unico setFieldValue en el callback para evitar los problemas de sincronizacion al usarlo multiples veces para el mismo campo
              if (!(disabledIfInitialValueExists && disableZonaAfectada)) {
                setFieldValue("zonaAfectada", newValueZonaAfectada ?? null);
              }
              if (!(disabledIfInitialValueExists && disableNaturalezaLesion)) {
                setFieldValue("naturalezaLesion", newValueNaturalezaLesion ?? null);
              }

            });
          }}
          getOptions={() => dispatch(getFormDiagnosis(idArt))}
          sx={StyledCommonForms.input}
          renderOption={(option) => `${option.id} - ${option.nombre}`}
          filterOptions={(option) => option.id + option.nombre}
          disabled={disabled || (disabledIfInitialValueExists && initialValues.diagnosticoOMS && !showDiagnosticoInformadoArt)}
        />
      </StyledCommonForms.RowContainer>
      {showDiagnosticoInformadoArt &&
        <StyledCommonForms.RowContainer>
          <DarkerDisabledTextFieldWrapper
            label="Diagnóstico informado por la ART"
            type="text"
            variant="outlined"
            value={values.diagnostico}
          />
        </StyledCommonForms.RowContainer>
      }
      {showDescripcionDiagnostico &&
        <StyledCommonForms.RowContainer>
          <FormikTextFieldSpeech
            id="diagnostico"
            name="diagnostico"
            label={`Descripción del diagnóstico ${fields.diagnostico.required ? "*" : ""
              }`}
            type="text"
            variant="outlined"
            multiline
            minRows={3}
            sx={StyledCommonForms.input}
            disabled={disabled}
          />
        </StyledCommonForms.RowContainer>
      }
      <StyledCommonForms.RowContainer>
        <NaturalezaLesionControl
          disabled={disableNaturalezaLesion}
          updateFilteredZonasAfectadas={updateFilteredZonasAfectadas}
          updateFilteredNaturalezasLesion={updateFilteredNaturalezasLesion}
          naturalezasLesion={naturalezasLesion}
          required={fields.naturalezaLesion.required}
          artId={idArt}
          sx={StyledCommonForms.input}
        />
      </StyledCommonForms.RowContainer>
      <StyledCommonForms.RowContainer>
        <ZonaAfectadaControl
          disabled={disableZonaAfectada}
          updateFilteredNaturalezasLesion={updateFilteredNaturalezasLesion}
          zonasAfectadas={zonasAfectadas}
          artId={idArt}
          sx={StyledCommonForms.input}
          required={fields.zonaAfectada.required}
        />
      </StyledCommonForms.RowContainer>
      {showGravedad &&
        <StyledCommonForms.RowContainer>
          <FormikSelect
            name="gravedad"
            label={`Gravedad ${fields.gravedad.required ? "*" : ""}`}
            variant="outlined"
            sx={StyledCommonForms.input}
            disabled={disabled}>
            {fields.gravedad.options.map((g) => (
              <MenuItem value={g} key={g}>
                {g}
              </MenuItem>
            ))}
          </FormikSelect>
        </StyledCommonForms.RowContainer>
      }
    </>
  )
}

export default DiagnosisControl;